import { useEffect, useRef } from "react";
import { useAuth as useClerkAuth, useUser } from "@clerk/react";
import { useAuth } from "../context/AuthContext";

/** Synchronise la session Clerk avec les cookies JWT Faanuu. */
export default function ClerkSessionBridge() {
  const { isLoaded, isSignedIn, getToken } = useClerkAuth();
  const { user: clerkUser } = useUser();
  const { syncClerkSession, clearFaanuuSession, user } = useAuth();
  const syncing = useRef(false);
  const lastSyncedClerkId = useRef(null);

  useEffect(() => {
    if (!isLoaded) return;

    if (!isSignedIn) {
      lastSyncedClerkId.current = null;
      if (user) clearFaanuuSession();
      return;
    }

    const clerkId = clerkUser?.id;
    if (!clerkId || syncing.current) return;

    const email = user?.email || "";
    const needsProfileRefresh =
      email.endsWith("@clerk.local") ||
      email.endsWith("@firebase.local") ||
      (!user?.avatar && Boolean(clerkUser?.imageUrl));
    if (lastSyncedClerkId.current === clerkId && user && !needsProfileRefresh) return;

    syncing.current = true;
    (async () => {
      try {
        const token = await getToken();
        if (token) {
          await syncClerkSession(token);
          lastSyncedClerkId.current = clerkId;
        }
      } catch {
        /* erreur affichée par AuthContext */
      } finally {
        syncing.current = false;
      }
    })();
  }, [
    isLoaded,
    isSignedIn,
    clerkUser?.id,
    clerkUser?.imageUrl,
    getToken,
    syncClerkSession,
    clearFaanuuSession,
    user,
  ]);

  return null;
}
